import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material';
import BenefitDetailCard from './BenefitDetailCard';
import ClubProgressSlider from './ClubProgressSlider';
import { downloadInsuranceCardAction, downloadShopInsuranceCardAction, ShopInsuranceDetailAction } from '../APIs/action';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import InfoRow from './InfoRow';
import { DownloadOutlined } from '../../../../components/icons';
import { useSelector } from 'react-redux';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { CustomButton } from '../../../MUI_custom_component';

const ShopDetails = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const insuranceType = location.state?.insuranceType;
	const selectedManufacturer = location.state?.selectedManufacturer;
	const selectedCompanyEntity = location.state?.selectedCompanyEntity;

	const [benefitDetail, setBenefitDetail] = useState([]);
	const [loader, setLoader] = useState(false);

	const benefitDetails = benefitDetail?.benefit_card;
	const clubProgressDetails = benefitDetail?.club_progress_details;
	const details = benefitDetail?.details || [];
	const getBenefitDetail = async (selectedManufacturer, insuranceType, selectedCompanyEntity) => {
		setLoader(true);
		try {
			const { data, message, error } = await ShopInsuranceDetailAction( selectedManufacturer, selectedCompanyEntity );
			setLoader(false);
			if (!error) {
				setBenefitDetail(data);
			} else {
				toast.error(message);
				setLoader(false);
			}
		} catch (error) {
			console.error('Error fetching benefit details:', error);
			toast.error('Failed to load benefit details');
			setLoader(false);
		}
	};
	useEffect(()=>{
		if(selectedManufacturer && insuranceType && selectedCompanyEntity){
			getBenefitDetail(selectedManufacturer, insuranceType, selectedCompanyEntity);
		} else {
			navigate('/benefits/mybenefits', { replace: true });
		}
	},[ selectedManufacturer, insuranceType, selectedCompanyEntity ])
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector(state => state.user?.userData);
      
  const handleDownloadECard = async () => {
      if (isLoading) return;
      
      // Track eCard download event
      trackAnalyticsEvent('INSURANCE_DETAILS_ECARD_DOWNLOAD_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        benefit_type: insuranceType || '',
      });
    
      try {
        setIsLoading(true);
        const downloadPromise = downloadShopInsuranceCardAction(
          selectedCompanyEntity,    // company_esi_id
          'Certificate.pdf'         // file_name
        );
        const minDelayPromise = new Promise(resolve => setTimeout(resolve, 1000));
        
        await Promise.all([downloadPromise, minDelayPromise]);
        
        const isInWebView = window.navigator.userAgent.includes('wv') || 
                            window.navigator.standalone || 
                            window.matchMedia('(display-mode: standalone)').matches;
        
        if (isInWebView) {
          console.log('Download initiated successfully');
        }
      } catch (error) {
        console.error('Download failed:', error);
      } finally {
        setIsLoading(false);
      }
  };
	
	if (loader) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<CircularProgress/>
			</Box>
		);
	}
	return (
		<Box sx={{ p: { xs:2, md:3 } }}>
			<Grid container spacing={{xs:2, md:4}} sx={{ mb: 2 }}>
				<Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
					<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2, background: '#ffffff', borderRadius: 2 }}>
						<BenefitDetailCard benefitDetails={benefitDetails} spacing={false}/>
					</Box>
				</Grid>
				{clubProgressDetails && (
					<Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
						<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', background: '#ffffff', borderRadius: 2, }}>
							<ClubProgressSlider progress={clubProgressDetails} insurance={false} />
						</Box>
					</Grid>
				)}
        		<Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column'}}>
					{details.length > 0 && (
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2, borderRadius: '16px', backgroundColor: '#fff' }}>
							<Typography variant="h3">
								Shop Policy Details
							</Typography>
							<Box>
								{details.map((detail, index) => (
									<InfoRow
										key={index}
										label={detail.display_name}
										value={detail.display_value}
									/>
								))}
							</Box>
							<CustomButton	
								variant="outlined"
								color="primary"
								label="Certificate"
								rightIcon={DownloadOutlined}
								onClick={() => {
									handleDownloadECard();
								}}
								loading={isLoading}
							/>
						</Box>
					)}
				</Grid>
			</Grid>
		</Box>
	);
};

export default ShopDetails;
